export default __webpack_public_path__ + "static/media/Trecontrade-2017_33_FA.94f99501.jpeg";